"use strict";

jQuery(function($) {
    /*
     * Update some of the header elements using AJAX
     */
    function update_mini_cart() {
        $.ajax({
            url : themevars.ajaxurl,
            data : {
                action : 'update_header',
            },
            type : 'POST',
            dataType : 'json'
        }).done( function ( response ) {
            if (true !== response.success) {
                return;
            }

            if (0 < response.data.shop_quantity) {
                $('[data-shop-icon-quantity]').html(response.data.shop_quantity).removeClass('d-none');
                $('[data-shop-icon]').attr('href', response.data.shop_icon_url);
            }

            if (true === response.data.is_logged_in) {
                $('[data-add-logged-in-class]').addClass('logged_in');
            }
        });
    }


    update_mini_cart();

    $('body').on('added_to_cart', function(e, fragments, cart_hash, $thisbutton) {
        update_mini_cart();
    });

    $('body').on('updated_cart_totals', function(e, data) {
        update_mini_cart();
    });

});